import React, { Component } from 'react';
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import ReactTable from 'react-table';
import ReactExport from 'react-data-export';
import InfoTable from './../Components/InfoTable';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const PAGE_SIZE = 10;
const TOTAL_PAGES = 5;

const MOCK_MOVEMENTS = Array.from({ length: PAGE_SIZE * TOTAL_PAGES }, function (_, index) {
    const movementNumber = index + 1;
    const amount = (100 + movementNumber * 7.35).toFixed(2);
    const commission = (Number(amount) * 0.018).toFixed(2);

    return {
        branchCode: 'MOCK' + String((movementNumber % 3) + 1).padStart(3, '0'),
        name: 'Esercizio demo ' + ((movementNumber % 3) + 1),
        date: String((movementNumber % 28) + 1).padStart(2, '0') + '/07/2026',
        summary: 'Movimento fittizio #' + movementNumber,
        pos: 'POS-' + String(1000 + movementNumber),
        amount: amount,
        autorization: 'AUTH' + String(100000 + movementNumber),
        pan: '************' + String(1000 + movementNumber).slice(-4),
        status: movementNumber % 6 === 0 ? 'ANNULLATO' : 'VALIDO',
        commission: commission,
        net: (Number(amount) - Number(commission)).toFixed(2)
    };
});

// Route di sola preview: nessun controller, API o sessione viene usato.
class MovimentiMock extends Component {
    constructor(props) {
        super(props);
        this.state = { currentPage: 1 };
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
    }

    prevPage() {
        this.setState(function (state) {
            return { currentPage: Math.max(1, state.currentPage - 1) };
        });
    }

    nextPage() {
        this.setState(function (state) {
            return { currentPage: Math.min(TOTAL_PAGES, state.currentPage + 1) };
        });
    }

    render() {
        const startIndex = (this.state.currentPage - 1) * PAGE_SIZE;
        const currentPageRows = MOCK_MOVEMENTS.slice(startIndex, startIndex + PAGE_SIZE);
        const columns = [
            { Header: 'CODICE ESERCIZIO', accessor: 'branchCode', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'INSEGNA', accessor: 'name', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'DATA', accessor: 'date', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'RIFERIMENTO', accessor: 'summary', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'POS', accessor: 'pos', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'LORDO', accessor: 'amount', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'AUTORIZZAZIONE', accessor: 'autorization', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'NUMERO CARTA', accessor: 'pan', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'STATO', accessor: 'status', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'COMMISSIONE', accessor: 'commission', headerClassName: 'sH', style: { fontSize: '10px' } },
            { Header: 'NETTO', accessor: 'net', headerClassName: 'sH', style: { fontSize: '10px' } }
        ];

        return (
            <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                <Box className='contentbox'>
                    <Box pad='medium' align='start' style={{ paddingBottom: '20px' }}>
                        <Text className='titlehome'><h1>Consulta Movimenti — Mock locale</h1></Text>
                        <Text className='subtitlehome'><h3>Dataset fittizio di 50 movimenti, distribuiti su 5 pagine</h3></Text>
                    </Box>

                    <Box>
                        <Box className='table' style={{ paddingTop: '20px', textAlign: 'left' }}>
                            <Text className='searchResult'>RISULTATI DI RICERCA</Text>
                        </Box>
                        <InfoTable
                            Title1='Cod Societario:'
                            Title2='Punto Vendita:'
                            Title3='Insegna:'
                            Title4='Periodo:'
                            Title5='Nr Movimenti:'
                            Title6='Totale Lordo:'
                            Title7='Totale Commissioni:'
                            Title8='Totale Netto:'
                            Result1='MOCK-SOC-001'
                            Result2='Tutti'
                            Result3='Esercenti demo'
                            Result4='Luglio 2026'
                            Result5={MOCK_MOVEMENTS.length}
                            Result6='€ 14.371,25'
                            Result7='€ 258,68'
                            Result8='€ 14.112,57'
                            secondColumn={true}
                        />
                        <Box direction='row' style={{ padding: '0 2%' }}>
                            <Box pad='large' style={{ width: '100%', padding: '0' }}>
                                <ReactTable
                                    data={currentPageRows}
                                    columns={columns}
                                    sortable={true}
                                    multiSort={false}
                                    resizable={true}
                                    showPagination={false}
                                    defaultPageSize={PAGE_SIZE}
                                    style={{ paddingBottom: '20px' }}
                                />
                                <div style={{ height: '50px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <button
                                        type='button'
                                        aria-label='Pagina precedente'
                                        style={{ width: '20px', height: '30px', color: this.state.currentPage === 1 ? '#999' : '#006fcf', cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer', background: 'none', border: 'none', padding: 0 }}
                                        onClick={this.prevPage}
                                        disabled={this.state.currentPage === 1}>
                                        <i className='icon-left-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }}></i>
                                    </button>
                                    <Text className='pag' style={{ fontSize: '12px', marginBottom: '12px' }}>{this.state.currentPage} di {TOTAL_PAGES}</Text>
                                    <button
                                        type='button'
                                        aria-label='Pagina successiva'
                                        style={{ width: '20px', color: this.state.currentPage === TOTAL_PAGES ? '#999' : '#006fcf', cursor: this.state.currentPage === TOTAL_PAGES ? 'not-allowed' : 'pointer', background: 'none', border: 'none', padding: 0 }}
                                        onClick={this.nextPage}
                                        disabled={this.state.currentPage === TOTAL_PAGES}>
                                        <i className='icon-right-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }}></i>
                                    </button>
                                </div>
                            </Box>
                        </Box>
                        <Box direction='row' className='footerTable rowColumn'>
                            <Box className='contentXsls'>
                                <ExcelFile filename='Movimenti-mock-tutte-le-pagine' element={<Box direction='row'><Text className='export'>ESPORTA TUTTE LE PAGINE<i className='icon-xlsx-file-format-extension' style={{ fontSize: '20px', marginLeft: '10px', verticalAlign: 'middle' }}></i></Text></Box>}>
                                    <ExcelSheet data={MOCK_MOVEMENTS} name='Movimenti'>
                                        <ExcelColumn label='CODICE ESERCIZIO' value='branchCode' />
                                        <ExcelColumn label='INSEGNA' value='name' />
                                        <ExcelColumn label='DATA' value='date' />
                                        <ExcelColumn label='RIFERIMENTO' value='summary' />
                                        <ExcelColumn label='POS' value='pos' />
                                        <ExcelColumn label='LORDO' value='amount' />
                                        <ExcelColumn label='AUTORIZZAZIONE' value='autorization' />
                                        <ExcelColumn label='NUMERO CARTA' value='pan' />
                                        <ExcelColumn label='STATO' value='status' />
                                        <ExcelColumn label='COMMISSIONE' value='commission' />
                                        <ExcelColumn label='NETTO' value='net' />
                                    </ExcelSheet>
                                </ExcelFile>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default MovimentiMock;
